module.exports = __webpack_public_path__ + "media/common/images/badges/gray/nezdolna_energie-c999d316b2a48658547352c372cec3e9.svg";